/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Sort_UpdatedInputs */

const cs_documents_sort_updated = /** @type {(inputs: Documents_Sort_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naposledy změněné`)
};

const en_documents_sort_updated = /** @type {(inputs: Documents_Sort_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recently changed`)
};

/**
* | output |
* | --- |
* | "Recently changed" |
*
* @param {Documents_Sort_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_sort_updated = /** @type {((inputs?: Documents_Sort_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Sort_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_sort_updated(inputs)
	return cs_documents_sort_updated(inputs)
});